import { errorNotification, notInternalRespondErrorNotification } from 'utils';
import { apiUrl } from 'config';
import * as requestTypes from 'constants/requestTypes';
import setRequestInProcess from 'actions/request';
import api from 'utils/api';

export const fetchAppraisalPayment = (token) => async () => {
  const url = `/applications/${token}/appraisal_payment`;
  try {
    const { data } = await api.get(url);

    return data;
  } catch (res) {
    if (res.status === 500) errorNotification();
    else {
      notInternalRespondErrorNotification({}, `Could not initiate PayPal Checkout ${res}`);
    }

    return res;
  }
};

export const createAppraisalPayment = ({ token, ...values }) => () => {
  const url = `/applications/${token}/appraisal_payment`;

  return api.post(url, values);
};

export const createOrder = (token) => async (dispatch) => {
  const url = `/applications/${token}/appraisal_payment/create_order`;
  const requestType = requestTypes.APPRAISAL_PAYMENT;

  dispatch(setRequestInProcess(true, requestType));

  try {
    const response = await api.post(url);
    dispatch(setRequestInProcess(false, requestType));
    const { orderId } = response;
    if (orderId) return orderId;
    const errorDetail = response.details && response.details[0];
    const errorMessage = errorDetail
      ? `${errorDetail.issue} ${errorDetail.description} (${response.debug_id})`
      : JSON.stringify(response);
    notInternalRespondErrorNotification({}, errorMessage);
  } catch (error) {
    dispatch(setRequestInProcess(false, requestType));

    const errorMessage = error.message || error;
    notInternalRespondErrorNotification({}, `Could not initiate PayPal Checkout ${errorMessage}`);
  }
};

export const onApprove = (token, data, setSuccessTrue) => async (dispatch) => {
  const requestType = requestTypes.APPRAISAL_PAYMENT;

  dispatch(setRequestInProcess(true, requestType));

  try {
    const orderData = await api.post(
      `${apiUrl}/applications/${token}/appraisal_payment/capture_order`,
      { appraisal_payment: data },
    );

    dispatch(setRequestInProcess(false, requestType));
    setTimeout(setSuccessTrue, 500);
  } catch (error) {
    dispatch(setRequestInProcess(false, requestType));

    notInternalRespondErrorNotification({}, error.errors.source);
  }
};
